<script>
import resources from './resources'

export default {
  name: 'professional-login-form',

  mixins: [resources]
}
</script>

<template lang="pug">
pagefull(title="Login", icon="")
  .container-fluid
    .row
      section#mobile-image.col-xs-12.hidden-md.hidden-lg
      section#login-form.col-xs-12.col-md-6
        .col-xs-12.col-sm-10.col-sm-offset-1
          a
           img.mb-cursor-point(src='/static/images/logo.svg', width='60%', height='100', @click.prevent="goToLoadingPageProfessional()")
          //-a(href='http://fusan.medibook.com.br/professional/loading-page/index')
            //-object.logo(data='logo.svg', width='186', height='235', type='image/svg+xml')
            img(src='/static/images/logo.svg', width='60%', height='100')

          ul.nav.nav-tabs.faq-cat-tabs
              li
                 router-link(:to="{name: 'auth.professional.login'}")
                  a(href='#') Pessoa Física
              li.active
                a(href='') Pessoa Jurídica
              li
                router-link(:to="{name: 'auth.collaborator.login'}")
                  a(href='') Colaborador

          .tab-content
            #pf-insert.tab-pane.active.in.fade
              .col-xs-12.white-bg
                .row
                  br
                  .col-xs-12.col-sm-12
                    .row(v-if="credentials.type === 'company'")
                      .col-xs-12
                        v-input-country-register(:status="$v.credentials.countryregister.$error ? 'error' : null")
                         f-text(
                            label="CNPJ"
                            v-model="credentials.countryregister",
                            name="countryregister",
                            autofocus,
                            :errors="errors['countryregister']")

                         p.help-block(v-if='$v.credentials.countryregister.$error && !$v.credentials.countryregister.required && !$v.credentials.countryregister.countryRegister')
                          strong O campo é obrigatorio.
                          
                         p.help-block(v-if='$v.credentials.countryregister.$error && !$v.credentials.countryregister.countryRegister && $v.credentials.countryregister.required')
                          strong Favor informar um CNPJ válido.

                    .form-group(:class="{'has-error is-empty': $v.credentials.password.$error}")
                      v-text(
                        label="Senha"
                        type="password"
                        id="password"
                        name="password"
                        v-model="credentials.password"
                        autocomplete="off"
                        :status="$v.credentials.password.$error ? 'error' : null"
                        @blur="$v.credentials.password.$touch()"
                        @keyup.enter="doLogin()")

                      p.help-block(v-if='$v.credentials.password.$error')
                        strong(v-if='!$v.credentials.password.required')
                          | O campo senha é obrigatório.
                    .form-group(style="text-align: center;", v-if="loginFail")
                      p( style="color: #A94443;")
                        strong
                          | Ocorreu um erro ao autenticar, verifique seus dados.
                    .row
                      .checkbox
                        .col-sm-12.col-md-6
                          label
                            input(type='checkbox', v-model="credentials.remember")
                            |  Mantenha-me Conectado
                        .col-sm-12.col-md-6.text-right.retrieve-pass
                          router-link(:to="{name: 'recover.recover'}")
                            a(href='#') Esqueceu sua senha?

                    button.btn.btn-primary.pull-right(@click.prevent="doLogin()")
                      | Acessar
                      span.icon 
          .clearfix
          .sign-up
            .col-sm-12.text-center
              | Ainda não possui uma conta?
            .col-sm-6.font-size-11
              router-link(:to="{name: 'register.professional'}")
                strong Cadastre-se agora como pessoa física
            .col-sm-6.font-size-11
              router-link(:to="{name: 'register.company'}")
                strong Cadastre-se agora como pessoa jurídica

      section#image.hidden-xs.hidden-sm.col-md-6
        .col-xs-10.col-xs-offset-1
          h2
            | O Medibook
            br
            |  simplifica a saúde!
            br
            strong Seja bem-vindo ao Medibook!
</template>

<style scoped>
.form-group {
  margin-bottom: 11px;
}

import('../static/css/bootstrap.min.css')

body{font-family: 'Open Sans', sans-serif !important;color: #333333 !important;background:#f4f7fa;}

html, body, .ui-page, .container-fluid{height: 100%;}

.ui-loader{display: none;}

a, a:hover, a:visited, a:focus{text-decoration: none; color: inherit;}

.btn-primary{
    border: none;
    background: #2071b8;
    text-shadow: none;
    border-radius: 30px;
    padding: 6px 20px;
    font-size: 16px;
    -webkit-transition: padding ease .3s, background ease .3s;
    transition: padding ease .3s, background ease .3s
}

.btn-primary:hover, .btn-primary:focus, .btn-primary:active {
    background:#2b9ac1;
    border-color: #387ab9;
    padding: 6px 15px 6px 25px;
}

span.icon{font-family: 'agenda-font-icons';font-size: 1.1em;margin: 0px 5px;}

button span.icon{
    font-family: 'agenda-font-icons';
    color: #fff;
}

#login-form{
    height: 100vh;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-line-pack: center;
    align-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

#login-form .col-xs-10{
    overflow: hidden;
}

#login-form svg{height: 80px;margin-bottom: 15px;}

hr {
    margin-top: 0px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
}
/* .nav-tabs > li, .nav-tabs > li > a{
    border: none;
    background: #f4f7fa;
    margin-right: 0;
    color: #888899;
    -webkit-transition: border ease .3s;
    transition: border ease .3s
}

.nav-tabs > li.active > a{
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: #ec1a3c 1px solid;
    background: #f4f7fa;
}

.nav-tabs > li.active > a:hover{
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: #ec1a3c 1px solid;
    background: #f4f7fa;
}

.nav-tabs li a:hover{
    background: #f4f7fa;
    border-bottom: #bd202e 1px solid;
} */

#login-form form{
    margin-top: 30px;
}

select::-ms-expand{display:none;}
select{
    -webkit-appearance:none;
    -moz-appearance:none;
    -ms-appearance:none;
    -o-appearance:none;
    appearance:none;
}

.blue-addon{color: #FFFFFF;background: #ed193b;border: 1px solid #ed193b;}

.blue-addon span.icon{font-size: 1.2em;margin: 0px;}

.margin-bottom{margin-bottom: 30px;}

#login-form .checkbox{
    color: #888899;
    font-size: 1em;
}

#login-form .retrieve-pass a{
    color: #2071b8;
    -webkit-transition: color ease .3s;
    transition: color ease .3s
}

#login-form .retrieve-pass a:hover{
    color: #387ab9;
}

#login-form .btn-primary{
    margin-top: 30px;
}

#login-form .or{
    width: 100%;
    text-align: center;
    margin: 15px 0;
    position: relative
}

#login-form .or span{
    color: #888899;
    letter-spacing: .1em;
    background: #f4f7fa;
    display: inline-block;
    padding: 5px 15px;
    position: relative;
    z-index: 2;
}

#login-form .or:after{
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: #ccccdd;
    left: 0;
    top: 13px;
    z-index: 1;
}

#login-form .social{
    width: 100%;
    color: #888899 !important;
}

#login-form .social div{text-align: center;}

#login-form .social a{
    width: 41px;
    height: 41px;
    display: inline-block;
    margin-right: 30px;
    background: url('/static/images/login/social-icons.png') no-repeat;
    text-align: center;
}

#login-form .social a.facebook{
    background-position: -1px 0px;
}

#login-form .social a.facebook:hover{
    background-position: -1px -48px;
}

#login-form .social a.twitter{
    background-position: -54px 0px;
}

#login-form .social a.twitter:hover{
    background-position: -54px -48px;
}

#login-form .social a.linkedin{
    background-position: -107px 0px;
}

#login-form .social a.linkedin:hover{
    background-position: -107px -48px;
}

#login-form .social a.google{
    background-position: -160px 0px;
}

#login-form .social a.google:hover{
    background-position: -160px -48px;
}

#login-form .sign-up{
    margin-top: 30px;
    color: #aaaabb;
}

#login-form .sign-up a{
    color: #2071b8;
    position: relative;
    display: inline-block;
    border-bottom: #2071b8 1px solid;
}

#mobile-image{
    height: 25vh;
    background: url('/static/images/login/login-profissional.jpg') no-repeat left 25%;
    background-size: cover;
    position: relative;
}

#image{
    height: 100vh;
    background: url('/static/images/login/login-profissional.jpg') no-repeat left center;
    background-size: cover;
    position: relative;
}

#image:after{
    content: '';
    position: absolute;
    width: 100%;
    height: 300px;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,0)), to(rgba(0,0,0,.5)));
    background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,.5));
    bottom: 0;
    left: 0;
}

#image .col-xs-10{
    height: 100vh;
    position: relative;
    z-index: 2;
}

#image .col-xs-10 h2{
    position: absolute;
    bottom: 60px;
    color: #fff;
    text-shadow: 0px 3px 15px rgba(0,0,0,.25);
    font-family: 'Fira Sans',sans-serif;
    line-height: 120%;
}

#image .col-xs-10 h2:after{
    content: '';
    position: absolute;
    width: 45px;
    height: 3px;
    background:#ec1a3c;
    bottom: -15px;
    left: 0;
}

@media (max-width:992px){
    #login-form{
        height: auto;
        display: block;
        padding-top: 30px;
        padding-bottom: 60px;
        padding-left: 0px;
        padding-right: 0px;
    }

    #login-form svg{height: 50px;}

    #login-form svg image{
        width: 210px;
        height: auto;
    }

    #login-form .retrieve-pass{text-align: center;margin-top: 15px;}

    #login-form .btn-primary{
        margin-top: 15px;
        width: 100%;
    }

    #login-form .social a{margin-right: 0;margin-bottom: 15px;}

    #login-form .sign-up{text-align: center;}
}
</style>



// WEBPACK FOOTER //
// src/app/auth/login/company/form.vue